jQuery(document).ready(function($) {

  /*
  jQuery throttle / debounce - v1.1 - 3/7/2010 -- Rewritten to accommodate webpack compilation
  http://benalman.com/projects/jquery-throttle-debounce-plugin/
  */
  function st_throttle(e,f,j,i){var c=undefined;var h,d=0;if(typeof f!=="boolean"){i=j;j=f;f=c}function g(){var o=this,m=+new Date()-d,n=arguments;function l(){d=+new Date();j.apply(o,n)}function k(){h=c}if(i&&!h){l()}h&&clearTimeout(h);if(i===c&&m>e){l()}else{if(f!==true){h=setTimeout(i?k:l,i===c?e-m:e)}}}if($.guid){g.guid=j.guid=j.guid||$.guid++}return g}

  // Global function that works with dynamically generated content on the page
  function applyWhenElementExists(selector, myFunction, intervalTime) {
    var interval = setInterval(function() {
      if (jQuery(selector).length > 0) {
        myFunction();
        clearInterval(interval);
      }
    }, intervalTime);
  }


  /* HEADER ON SCROLL ------------------------------------------- */
  $(window).on('scroll', st_throttle(500, function() {

    var window_scroll_top = $(window).scrollTop();

    if (window_scroll_top > 50) {
      $('body').addClass('scrolled-header');
    } else {
      $('body').removeClass('scrolled-header');
    }

  }));


  /* MODAAL FUNCTIONALITY --------------------------------------- */

  // For text/image columns with a video button
  $('a.modaal-video').modaal({
    type: 'video'
  });

  // Additional-images gallery on the individual stone page. Each trigger shares a
  // data-group="stone-{id}" so Modaal treats the set as one gallery.
  $('.modaal-gallery').modaal({
    type: 'image'
  });


  // Handle the Roaming Stones submission form's hidden fields
  $('#nf-form-2-cont').each(function() {

    var $container = $(this);

    // Wait for the form to be loaded
    $(document).on('nfFormReady', function(e, layoutView) {

      // Determine the hidden fields we want to populate
      var $stone_title_field = $('#nf-field-15', $container);
      var $stone_code_field = $('#nf-field-14', $container);
      var $stone_gallery_id_field = $('#nf-field-13', $container);

      // Get source values
      var $values_container = $('#nf-hidden-field-info');
      var stone_title_field_value = $('.rss_hidden_stone_title', $values_container).text();
      var stone_code_field_value = $('.rss_hidden_stone_code', $values_container).text();
      var stone_gallery_id_field_value = $('.rss_hidden_stone_gallery_id', $values_container).text();

      // Set the values of the hidden fields
      $stone_title_field.val( stone_title_field_value ).trigger('change');
      $stone_code_field.val( stone_code_field_value ).trigger('change');
      $stone_gallery_id_field.val( stone_gallery_id_field_value ).trigger('change');

    });

  });


  /* SEARCH FORM FUNCTIONALITY ---------------------------------- */
  $('.search-form').each(function() {

    // Declare variables
    var $search_form = $(this);
    var $search_input = $('input[type="text"]', $search_form);
    var $search_submit = $('button[type="submit"]', $search_form);
    var placeholder_text = 'Enter your search term';

    // Set default placeholder appearance of input field
    if ($search_input.val() == '') {
      $search_input.val(placeholder_text);
    }

    // Handle focusing and blur of the field
    $search_input.on('focus', function() {

      if ($(this).val() == placeholder_text) {
        $(this).val('');
      }

    }).on('blur', function() {

      if ($(this).val() == '') {
        $(this).val(placeholder_text);
      }

    });

    // Handle submit, preventing it if the placeholder is still in-place
    $search_form.on('submit', function(e) {
      if ($search_input.val() == placeholder_text) {
        e.preventDefault();
      }
    });

  });


  /* HOME BANNER SLIDER ------------------------------------------ */

  $('.home-banner__slider').each(function() {

    var $slider = $(this);
    var $slides = $slider.find('.home-banner__slide');

    if ($slides.length < 2) {
      return;
    }

    var current_index = $slides.index($slides.filter('.is-active'));
    if (current_index < 0) {
      current_index = 0;
    }

    setInterval(function() {

      var next_index = (current_index + 1) % $slides.length;

      $slides.eq(current_index).removeClass('is-active');
      $slides.eq(next_index).addClass('is-active');

      current_index = next_index;

    }, 3000);

  });


  /* SMOOTH SCROLLING ------------------------------------------- */

  // Create an array of items not to smooth scroll
  var no_smooth_scrolling = '[href="#"], [href="#0"], [href*="#modal"], .mm-btn, .mm-wrapper__blocker';

  $('a[href*="#"]').not(no_smooth_scrolling).click(function(t){

    // Set variable determining if this is a keyboard click or a mouse click
    var event_type = t.originalEvent.detail;

    if(location.pathname.replace(/^\//,"")==this.pathname.replace(/^\//,"")&&location.hostname==this.hostname){

    var e = $(this.hash);

    // Determine the heights of possible elements on the page to take into consideration
    var header_height = 0;
    header_height = $('#header').innerHeight(); // Fixed headers need to be taken into consideration

    var wpadminbar_height = ($('#wpadminbar').length > 0 ? $('#wpadminbar').innerHeight() : 0); // Height of WordPress admin bar
    var scroll_top_padding = 20; // Extra padding

    // Calculate the final offset for scrolling by removing the height of the items above (and some padding) from the total offset height
    var e_offset_top = e.offset().top - (header_height + wpadminbar_height + scroll_top_padding);

  (e=e.length?e:$("[name="+this.hash.slice(1)+"]")).length&&(t.preventDefault(),$("html, body").animate({
    scrollTop:e_offset_top
  },1e3,function(){
    var t=$(e);

    // If this is a standard mouse click, set focusVisible to false
    if (event_type == 1) {
      if(t.focus({ focusVisible: false }),t.is(":focus"))return!1;
      t.attr("tabindex","-1"),t.focus({ focusVisible: false })
    } else {
      if(t.focus(),t.is(":focus"))return!1;
      t.attr("tabindex","-1"),t.focus()
    }
  }))}});

});
